const config = {
  baseURL: 'https://reactapi.celeuma.pt'
};

export default config;